module.exports = __webpack_public_path__ + "static/media/tri_sector1.a848c793.svg";